import { sounds } from 'stylewhere/assets'

const play = (file: any) => {
  try {
    const sound = new Audio(file)
    sound.addEventListener('canplaythrough', () => {
      sound.volume = 1
      sound.play().catch((e) => {
        console.log(e.message)
      })
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}

export default {
  confirmation: () => play(sounds.confirmation),
  error: () => play(sounds.error),
  fail: () => play(sounds.fail),
  next: () => play(sounds.next),
  scan: () => play(sounds.scan),
  success: () => play(sounds.success),
  tap: () => play(sounds.tap)
}
